const byOnlineAndPrinterCount = (a, b) => {
  if (a.workstationIsOnline && !b.workstationIsOnline) {
    return -1;
  }
  if (!a.workstationIsOnline && b.workstationIsOnline) {
    return 1;
  }
  if (a.workstationIsOnline && b.workstationIsOnline) {
    if (a.printers.length > b.printers.length) {
      return -1;
    }
    if (a.printers.length < b.printers.length) {
      return 1;
    }
  }
  return 0;
};

export const printerGrouper = {
  groupPrintersByWorkstation(workstations, printerGroups, userId, shouldExcludeUnusablePrinters) {
    const workstationMap = workstations.reduce((acc, workstation) => {
      return {
        ...acc,
        [workstation.workstationId]: workstation,
      };
    }, {});

    const printersByWorkstation = printerGroups.reduce((acc, printerGroup) => {
      const printerWorkstation = workstationMap[printerGroup.workstationId] || {};
      const printers = (printerGroup.printers || [])
        .filter((printer) => !printer.disabled && (printerWorkstation.userId === userId || printer.shared))
        .map((printer) => ({
          ...printer,
          workstationName: printerWorkstation.description,
        }));

      return {
        ...acc,
        [printerGroup.workstationId]: printers,
      };
    }, {});

    return workstations
      .filter((workstation) => {
        if (!shouldExcludeUnusablePrinters) {
          return true;
        }

        const printers = printersByWorkstation[workstation.workstationId] || [];
        return workstation.userId === userId || printers.some((printer) => printer.shared && !printer.disabled);
      })
      .map((workstation) => {
        const { isOnline } = workstation;
        const workstationPrinters = (printersByWorkstation[workstation.workstationId] || []).map((printer) => ({
          ...printer,
          workstationName: workstation.description,
        }));
        return {
          workstationName: workstation.description,
          workstationIsOnline: isOnline,
          printers: workstationPrinters,
          workstationId: workstation.workstationId,
        };
      })
      .sort(byOnlineAndPrinterCount);
  },
};
